import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";

export const BASE = {
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/clre/dclr/ntc/dclr-ntc-tansad`,
    api_com: `${process.env.REACT_APP_API_OSCI}/api/v1/clri/com/dclr/rprt/dclr-rprt-tansad`,
    nodes: [
        { path: "/", label: "L_CLR_DLCR" },
        { path: "/clre/dclr/", label: "L_INFO" },
        { path: "/clre/dclr/ntc", label: "L_DCLR" },
    ],
};

export const APIS = {
    getErrNtcDtl: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/err/ntc?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
};

export const SF_ERR_NTC_DTL_FORM: TFormSchema = {
    id: "form_ErrNtcLst",
    schema: {
        errNtcDtm: {
            type: "daterange",
            label: "L_TANSAD_DT",
            start: { name: "errNtcFrom" },
            end: { name: "errNtcTo" },
            rangeButton: 0,
            controlSize: 4,
        },
        referenceNo: {
            label: "L_REFF_NO",
            controlSize: 4,
        },

        reffTin: {
            type: "text",
            controlSize: 1,
            only: "control",
            maxLength: 9,
            imemode: "number",
            disabled: true,
        },
        reffYy: {
            type: "text",
            controlSize: 1,
            only: "control",
            maxLength: 2,
            imemode: "number",
            disabled: true,
        },
        reffSrno: {
            type: "text",
            controlSize: 1,
            only: "control",
            maxLength: 7,
            imemode: "number",
            disabled: true,
        },

        reffNo: {
            type: "text",
            controlSize: 4,
            edit: false,
            label: "L_REFF_NO",
        },
    },
};

export const SG_ERR_NTC_DTL_GRID: TGridSchema = {
    id: "grid",
    options: { pagination: "out", height: "auto", index: true },
    head: [
        { cells: [{ header: "L_ERR_LOCT", binding: "erkyCn4", width: "10%" }] },
        { cells: [{ header: "L_ITM_NO", binding: "erkyCn2", width: "13%" }] },
        { cells: [{ header: "L_MDL_NO", binding: "erkyCn3", width: "15%" }] },
        { cells: [{ header: "L_ERR_CN", binding: "errMsgCn", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "erkyCn4" }],
        },
        {
            cells: [{ binding: "erkyCn2" }],
        },
        {
            cells: [{ binding: "erkyCn3" }],
        },
        {
            cells: [{ binding: "errMsgCn" }],
        },
    ],
};
